import axios, { AxiosResponse } from 'axios';
import { UserUrl } from "./AUrl";
import { BodylessApiResponse } from "../interfaces";

interface AddLicensePayload {
    license_key: string;
}

/**
 * Adds a license to a user account.
 * @param token - The user's JWT token.
 * @param payload - The license data containing user_id and license_key.
 * @returns A promise that resolves to a BodylessApiResponse indicating success or failure.
 */
export async function addLicense(
    token: string,
    payload: AddLicensePayload
): Promise<BodylessApiResponse> {
    const url = new UserUrl().addLicense;
    let response: AxiosResponse<any>;

    try {
        response = await axios.post<string | null>(url, payload, {
            headers: {
                'Content-Type': 'application/json',
                'token': token
            },
            // Resolve the promise for all HTTP status codes
            validateStatus: () => true
        });
        console.log(response);
    } catch (error) {
        return {
            status: 500,
            message: 'Network or other error occurred'
        };
    }

    if (response.status === 201) {
        return {
            status: response.status,
            message: "License assigned successfully"
        };
    } else if (response.status === 409) {
        return {
            status: response.status,
            message: "User already has a license"
        };
    } else if (response.status === 403) {
        return {
            status: response.status,
            message: response.data as string || "Unknown error"
        };
    } else {
        return {
            status: response.status,
            message: "Unexpected error occurred"
        };
    }
}
